import { useEffect } from 'react';

import HeaderExtra from '../components/HeaderExtra'
import Footer from '../components/Footer.jsx';
import RightPanelMobile from '../components/RightPanelMobileToIns.jsx';

import '../Assets/css/paymentform.css'
import '../Assets/css/referralmenu.css'
import '../Assets/css/vouchermenu.css'

import  '../Assets/js/vouchermenu.js'
// import  '../Assets/js/datetimefunc.js'

function VoucherMenu()
{
  useEffect(() =>
  {
    window.CallDefaultFunction("VoucherMenu");
  }, []);

  return (
    <>
      <div className="basic">

        <HeaderExtra />

        <div className="MainContentSection" id="AllMainContentSection">
          <div className="MainSectionBasicWithBlue" style={{WebkitFlexDirection:"column",msFlexDirection:"column",flexDirection:"column"}}>
            <div className="BlueFilterSortContainerReward BasicRadius">
              <div className="SmallPanelDropDownContainer" id="RewardSelectedDropDownContainer">
                <div className="SmallPanelDropDownInputWrapper Selectable3 InterMediumTextFont">
                  <p className="MonthInputChangeCurrentSelectedText" id="RewardSelectedDropDownText">Voucher PinginGo</p>
                  <img className="ChevronInsideInput ToggleArrow" id="RewardSelectedDropDownChevron" src="/Assets/images/ButtonIcon/chevron.svg" style={{"rotate":"0deg"}} />
                </div>
              </div>
            </div>
            <div className="ReferralContentWrapper" style={{marginTop:"0",WebkitFlexDirection:"column",msFlexDirection:"column",flexDirection:"column"}}>
              <div className="BasicTextButton TopReferralSectionButtonContainer">
                <div style={{WebkitFlex:"1",msFlex:"1",flex:"1",height:"fit-content",display:"flex",zIndex:"1"}}>
                  <button className="TopReferralSectionButton BasicRadius BasicBoxShadowUp Selectable2 TopReferralSectionSelected" style={{borderBottomLeftRadius:0,borderBottomRightRadius:0}} id="PinginGoVoucherFilterButton">
                    <p className="LabelGreyHeaderSmallerText2 InterBoldTextFont">Voucher PinginGo</p>
                  </button>
                  <button className="TopReferralSectionButton BasicRadius BasicBoxShadowUp Selectable2" style={{borderBottomLeftRadius:0,borderBottomRightRadius:0}} id="VoucherPartnerFilterButton">
                    <p className="LabelGreyHeaderSmallerText2 InterBoldTextFont">Voucher Partner</p>
                  </button>
                  <button className="TopReferralSectionButton BasicRadius BasicBoxShadowUp Selectable2" style={{borderBottomLeftRadius:0,borderBottomRightRadius:0}} id="GiftRewardFilterButton">
                    <p className="LabelGreyHeaderSmallerText2 InterBoldTextFont">Reward</p>
                  </button>
                </div>
                <div className="SelectedSortOrangeWrapper" id="SelectedSortOrangeWrapper" style={{"left":"0%",width:"33.33%"}}>
                  <div className="SelectedSortOrange BasicRadius" style={{width:"100%",borderBottomLeftRadius:"0",borderBottomRightRadius:0}} />
                </div>
              </div>
              <div className="BasicTextButton BasicBoxShadow AllContentMarginPayment BasicRadius" style={{backgroundColor:"#F9FAFB"}}>
                <div className="RewardMainWrapper">
                  <div className="RewardFilterWrapper" id="Filter2ButtonContainer">
                    <div className="BasicTextButton SignInButtonTop FilterTextContainer">
                      <div style={{width:"fit-content",height:"fit-content",display:"flex", margin:"auto 0"}}>
                        <img src="/Assets/images/ButtonIcon/3-line-filter-blue.svg" className="BasicIconInsideButton2" style={{marginLeft:"0"}} />
                        <p style={{"color":"#1D76AE"}}>Filter:</p>
                      </div>
                    </div>
                    <button className="BasicTextButton BasicBoxShadow BlueButtonLight SignInButtonTop Selectable Filter2Buttons">
                      <p className="LengthyBtnTxt">Semua Voucher</p>
                      <p className="ShortenedBtnTxt">Semua</p>
                    </button>
                    <button className="BasicTextButton BasicBoxShadow BlueOutlineButton SignInButtonTop Selectable Filter2Buttons">
                      <p className="LengthyBtnTxt">Voucher Tersedia</p>
                      <p className="ShortenedBtnTxt">Tersedia</p>
                    </button>
                    <button className="BasicTextButton BasicBoxShadow BlueOutlineButton SignInButtonTop Selectable Filter2Buttons">
                      <p className="LengthyBtnTxt">Voucher Terpakai</p>
                      <p className="ShortenedBtnTxt">Terpakai</p>
                    </button>
                    <button className="BasicTextButton BasicBoxShadow BlueOutlineButton SignInButtonTop Selectable Filter2Buttons">
                      <p className="LengthyBtnTxt">Voucher Kadaluwarsa</p>
                      <p className="ShortenedBtnTxt">Kadaluwarsa</p>
                    </button>
                  </div>
                  <div className="RewardGridAndLoadMoreButtonContainer HideScrollBar BasicGradientTopBottomMask">
                    <div className="RewardGridContainer" id="RewardGridContainer" style={{display:"none"}}>
                      <div className="VoucherMainPanel BasicBoxShadow BasicRadius SpecialHovSelectable">
                        <div className="TopRewardSection TargetSpecialHovSelect">
                          <div className="VoucherImageContainer">
                            <p className="SmallRoundedText InterMediumTextFont" style={{backgroundColor:"#12b76a","color":"#ffffff"}}>Sisa 2</p>
                            <img src="/Assets/images/AnimateBG/1.jpg" className="ImageFullCover" />
                          </div>
                          <div className="VoucherInfoWrapper">
                            <div className="BasicChildMargin2 InputFieldMargin3" style={{display:"flex"}}>
                              <p className="LabelGreyHeaderSmallerText2 InterBoldTextFont">Discount Referral 100rb</p>
                            </div>
                            <div className="RewardInfoSeparatorWrapper">
                              <div className="PoinWithIconWrapper BasicChildMargin2 InputFieldMargin4">
                                <img src="/Assets/images/ButtonIcon/clock-icon-orange.svg" style={{marginLeft:"0"}} />
                                <div className="RewardInfoSmallWrapper">
                                  <p className="SmallerRoomDescriptionText InterRegularTextFont" style={{"color":"#797979"}}>Berlaku s/d</p>
                                  <p className="SmallerRoomDescriptionText InterRegularTextFont" style={{marginLeft:"auto"}}>1 Oct 2024 - 30 Dec 2024</p>
                                </div>
                              </div>
                              <div className="PoinWithIconWrapper BasicChildMargin2 InputFieldMargin4">
                                <img src="/Assets/images/ButtonIcon/RP-icon.svg" style={{marginLeft:"0"}} />
                                <div className="RewardInfoSmallWrapper">
                                  <p className="SmallerRoomDescriptionText InterRegularTextFont" style={{"color":"#797979"}}>Min. Transaksi</p>
                                  <p className="SmallerRoomDescriptionText InterRegularTextFont" style={{marginLeft:"auto"}}>Tidak ada Minimum</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="KodeVoucherWrapper">
                          <p className="SmallerRoomDescriptionText InterMediumTextFont" style={{"color":"#797979"}}>Kode Voucher</p>
                          <div className="CopyCodeContainer">
                            <p className="LabelGreyHeaderSmallerText2 InterRegularTextFont CopyText" style={{"color":"rgb(29, 41, 57)"}}>YOSIAOKAPU0526 <img className="Selectable2 CopyRewardIcon" src="/Assets/images/ButtonIcon/orange-copy-icon.svg" id="CopyRefIconButton" /></p>
                            <button className="BasicTextButton BasicBoxShadow BlueButton SignInButtonTop Selectable">
                              <div style={{width:"fit-content",height:"fit-content",display:"flex","margin":"auto","opacity":"1"}}>
                                <img src="/Assets/images/ButtonIcon/copy-white-icon.svg" className="BasicIconInsideButton2" style={{marginLeft:"0"}} />
                                <p id="TukarPointButtonText">Copy</p>
                              </div>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="VoucherMainPanel BasicBoxShadow BasicRadius ">
                        <div className="TopRewardSection">
                          <div className="VoucherImageContainer loading_grey">
                          </div>
                          <div className="VoucherInfoWrapper">
                            <div className="BasicChildMargin2 InputFieldMargin3" style={{display:"flex"}}>
                              <p className="LabelGreyHeaderSmallerText2 InterBoldTextFont loading_grey" style={{"color":"transparent"}}>Discount Referral 100rb</p>
                            </div>
                            <div className="RewardInfoSeparatorWrapper">
                              <div className="PoinWithIconWrapper BasicChildMargin2 InputFieldMargin4">
                                <div className="RewardInfoSmallWrapper">
                                  <p className="SmallerRoomDescriptionText InterRegularTextFont loading_grey" style={{"color":"transparent",width:"fit-content"}}>Berlaku s/d</p>
                                  <p className="SmallerRoomDescriptionText InterRegularTextFont loading_grey" style={{marginLeft:"auto","color":"transparent",width:"fit-content"}}>1 Oct 2024 - 30 Dec 2024</p>
                                </div>
                              </div>
                              <div className="PoinWithIconWrapper BasicChildMargin2 InputFieldMargin4">
                                <div className="RewardInfoSmallWrapper">
                                  <p className="SmallerRoomDescriptionText InterRegularTextFont loading_grey" style={{"color":"transparent",width:"fit-content"}}>Min. Transaksi</p>
                                  <p className="SmallerRoomDescriptionText InterRegularTextFont loading_grey" style={{marginLeft:"auto","color":"transparent",width:"fit-content"}}>Tidak ada Minimum</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="KodeVoucherWrapper">
                          <p className="SmallerRoomDescriptionText InterMediumTextFont loading_grey" style={{"color":"transparent",width:"fit-content"}}>Kode Voucher</p>
                          <div className="CopyCodeContainer loading_grey">
                            <p className="LabelGreyHeaderSmallerText2 InterRegularTextFont CopyText" style={{"color":"transparent"}}>Test1234 <img className="Selectable2 CopyRewardIcon" src="/Assets/images/ButtonIcon/orange-copy-icon.svg" style={{"opacity":"0"}} /></p>
                            <button className="BasicTextButton BasicBoxShadow BlueButton SignInButtonTop Selectable">
                              <div style={{width:"fit-content",height:"fit-content",display:"flex","margin":"auto","opacity":"0"}}>
                                <img src="/Assets/images/ButtonIcon/copy-white-icon.svg" className="BasicIconInsideButton2" style={{marginLeft:"0"}} />
                                <p id="TukarPointButtonText">Copy</p>
                              </div>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="NoFeaturedPropertyFoundContainer" id="NoVoucherFoundContainer">
                      <img src="/Assets/images/Icon/NoVoucherFound.svg" className="NoFoundIcon InputFieldMargin3" />
                      <p className="NoFoundHeaderText InterBoldTextFont" id="NoVoucherFoundHeaderText">Oops, no Voucher Found</p>
                      <p className="NoFoundMessageText InterRegularTextFont" style={{width:"85%"}} id="NoVoucherFoundMessageText">You don't have any <span className="InterBoldTextFont" /> in your account</p>
                    </div>
                    <button className="BasicTextButton BasicBoxShadow OrangeButton PaddingExtendedButton Selectable" style={{"margin":"auto",display:"none"}} id="LoadMoreRewardButton">
                      Load More
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
      <RightPanelMobile/>
      <Footer/>
    </>
  )
}

export default VoucherMenu